import { styled } from "@mui/material/styles";
import { Typography, Paper, Box, Button } from "@mui/material";

export const Root = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  minHeight: "100vh",
  // backgroundColor: "#f8fafc",
  padding: "20px",
});

export const JobCard = styled(Paper)({
  width: "100%",
  maxWidth: "1200px",
  padding: "24px",
  marginBottom: "24px",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
  display: "flex",
  alignItems: "flex-start",
  gap: "16px",
});

export const JobIcon = styled(Box)({
  width: "48px",
  height: "48px",
  borderRadius: "8px",
  backgroundColor: "#4f46e5",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
  fontSize: "20px",
  fontWeight: "bold",
  flexShrink: 0,
});

export const JobInfo = styled(Box)({
  flex: 1,
  minWidth: 0, // Allow flex item to shrink
});

export const JobTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: 600,
  color: "#1e293b",
  marginBottom: "4px",
});

export const JobSubtitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  color: "#64748b",
  marginBottom: "12px",
  wordBreak: "break-word",
  overflowWrap: "break-word",
});

export const JobDescription = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  color: "#64748b",
  marginBottom: "12px",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  lineHeight: 1.5,
});

export const JobMeta = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  flexWrap: "wrap",
});

export const JobMetaItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontSize: "14px",
  color: "#64748b",
});

export const StatusBadge = styled(Box)(({ status }) => ({
  marginLeft: "auto",
  padding: "6px 12px",
  borderRadius: "20px",
  fontSize: "14px",
  fontWeight: 500,
  backgroundColor: status === "ready" ? "#dcfce7" : status === "processing" ? "#fef3c7" : "#dcfce7",
  color: status === "ready" ? "#166534" : status === "processing" ? "#92400e" : "#166534",
  whiteSpace: "nowrap",
}));

export const DropzoneContainer = styled(Box)({
  width: "100%",
  maxWidth: "1200px",
  padding: "48px 24px",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
  border: "2px dashed #e2e8f0",
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    borderColor: "#4f46e5",
    backgroundColor: "#fafbff",
  },
});

export const UploadIcon = styled(Box)({
  width: "48px",
  height: "48px",
  margin: "0 auto 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "8px",
  backgroundColor: "#4f46e5",
  color: "white",
  fontSize: "24px",
});

export const DropzoneTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: "#1e293b",
  marginBottom: "8px",
});

export const DropzoneSubtitle = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  color: "#64748b",
  marginBottom: "24px",
});

export const SelectFilesButton = styled(Button)({
  borderRadius: "8px",
  padding: "12px 24px",
  backgroundColor: "#4f46e5",
  color: "white",
  textTransform: "none",
  fontSize: "16px",
  fontWeight: 500,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#4338ca",
    boxShadow: "0px 4px 12px rgba(79, 70, 229, 0.3)",
  },
});

export const ActionsContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: "20px",
  marginTop: "24px",
  width: "100%",
  maxWidth: "1200px",
});

export const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "8px",
  padding: "12px 24px",
  backgroundColor: theme.palette.primary.main,
  color: "white",
  textTransform: "none",
  fontSize: "16px",
  fontWeight: 500,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
    boxShadow: "0px 4px 12px rgba(79, 70, 229, 0.3)",
  },
}));

export const ProcessingContainer = styled(Box)({
  width: "100%",
  maxWidth: "1200px",
  padding: "48px 24px",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "200px",
});